import { render, staticRenderFns } from "./view-del-detail.vue?vue&type=template&id=5330d8cb&scoped=true&"
import script from "./view-del-detail.vue?vue&type=script&lang=js&"
export * from "./view-del-detail.vue?vue&type=script&lang=js&"
import style0 from "./view-del-detail.vue?vue&type=style&index=0&id=5330d8cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330d8cb",
  null
  
)

component.options.__file = "view-del-detail.vue"
export default component.exports